import React, { useEffect, useState, useRef } from 'react'
import InputField from '../../../feature-module/components/Input'
import { Controller, useForm } from 'react-hook-form'
import { ErrorToaster, SuccessToaster } from '../../../feature-module/components/toaster/Toaster'
import StoreServices from '../../../services/Store'
import { emailRegex } from '../../../utils'
import { modalCloseListener } from '../../../utils/helper'
import { PlusCircle, X } from 'feather-icons-react/build/IconComponents'
import { Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import IMask from 'imask'

const StoreModal = ({ updateData, resetUpdateData, getData }) => {

  const { register, handleSubmit, formState: { errors }, setValue, reset, control } = useForm();
  const [loading, setLoading] = useState(false);

  // *For Store Logo
  const [isLogo, setIsLogo] = useState({});

  // *For QR Code
  const [isQrCode, setIsQrCode] = useState({});

  // *For Upload Image
  const handleUploadImage = (e, type) => {
    try {
      if (e.target.value !== "") {
        const file = e.target.files[0]
        const imgReader = new FileReader();
        imgReader.onload = (event) => {
          let obj = {
            file: file,
            image: event.target.result
          }
          if (type === 'logo') {
            setIsLogo(obj)
          } else {
            setIsQrCode(obj)
          }
        };
        imgReader.readAsDataURL(file);
      }
    } catch (error) {
      console.log('handleUploadImage => error:', error)
    }
  };

  // *For Remove Image 
  const handleRemoveImage = async (type) => {
    try {
      if (type === 'logo') {
        setIsLogo({})
      } else {
        setIsQrCode({})
      }
    } catch (error) {
      console.log('handleRemoveImage => error:', error)
    }
  }

  // *For Submit Form
  const submitForm = async (data) => {
    setLoading(true)
    try {
      const formData = new FormData();
      formData.append('name', data?.name);
      formData.append('phone_number', data?.phone);
      formData.append('branch_code', data?.branchCode);
      formData.append('email', data?.email);
      formData.append('address', data?.address);
      formData.append('remarks', data?.remarks);
      formData.append('is_active', data?.status);
      if (isLogo?.file) {
        formData.append('logo', isLogo?.file);
      }
      if (isQrCode?.file) {
        formData.append('qrCode', isQrCode?.file);
      }

      if (updateData?.id) {
        // *Update 
        await StoreServices.updateStore(updateData?.id, formData)
        SuccessToaster('Update Successfully')
      } else {
        // *Create 
        await StoreServices.createStore(formData)
        SuccessToaster('Create Successfully')
      }
      reset();
      const btn = document.getElementById('modalClose')
      btn.click();
      getData();
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (updateData) {
      setValue('name', updateData?.name)
      setValue('phone', updateData?.phone_number)
      setValue('branchCode', updateData?.branch_code)
      setValue('email', updateData?.email)
      setValue('address', updateData?.address)
      setValue('remarks', updateData?.remarks)
      setValue('status', updateData?.is_active)
      setIsLogo({
        file: null,
        image: updateData?.logoBase64
      })
      setIsQrCode({
        file: null,
        image: updateData?.qrCodeBase64
      })
    }
  }, [updateData]);

  useEffect(() => {
    const cleanup = modalCloseListener("open-modal", () => {
      reset();
      resetUpdateData();
    });

    return cleanup;
  }, []);

  return (
    <div className="modal fade" id="open-modal">
      <div className="modal-dialog modal-dialog-centered custom-modal-two">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>{updateData?.id ? "Update Store" : "Create Store"}</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                <form onSubmit={handleSubmit(submitForm)}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <InputField
                          label="Name"
                          type="text"
                          error={errors?.name?.message}
                          register={register("name", {
                            required: 'Please enter store name.',
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        {/* <InputField
                          label="Phone"
                          type="tel"
                          error={errors?.phone?.message}
                          register={register("phone", {
                            required: 'Please enter phone.',
                          })}
                        /> */}
                        <Controller
                          name="phone"
                          control={control}
                          rules={{
                            required: "Please enter phone.",
                            pattern: {
                              value: /^\(\d{3}\) \d{3}-\d{4}$/,
                              message: "Invalid phone number format"
                            }
                          }}
                          render={({ field }) => {
                            const inputRef = useRef(null);
                            useEffect(() => {
                              if (inputRef.current) {
                                const mask = IMask(inputRef.current, {
                                  mask: '(000) 000-0000'
                                });
                                return () => mask.destroy();
                              }
                            }, []);
                            return (
                              <>
                                <label className="form-label">Phone</label>
                                <input
                                  {...field}
                                  ref={(e) => {
                                    field.ref(e);
                                    inputRef.current = e;
                                  }}
                                  className={`form-control ${errors?.phone?.message ? 'is-invalid' : ''} `}
                                  placeholder="(123) 456-7890"
                                />
                                <div className="invalid-feedback">{errors?.phone?.message}</div>
                              </>
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <InputField
                          label="Branch Code"
                          type="text"
                          error={errors?.branchCode?.message}
                          register={register("branchCode", {
                            required: 'Please enter branch code.',
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <InputField
                          label="Email"
                          type="email"
                          error={errors?.email?.message}
                          register={register("email", {
                            required: 'Please enter billing email.',
                            pattern: {
                              value: emailRegex,
                              message: 'Please enter a valid email.',
                            }
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="input-blocks">
                        <InputField
                          label="Address"
                          type="text"
                          error={errors?.address?.message}
                          register={register("address", {
                            required: 'Please enter address.',
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-blocks">
                        <InputField
                          label="Remarks"
                          inputType="textarea"
                          placeholder="Type Remarks"
                          register={register("remarks")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 mt-2 mb-4">
                      <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                        <span className="status-label">Status</span>
                        <InputField
                          id="checkbox1"
                          type="checkbox"
                          className="check"
                          defaultChecked={true}
                          register={register("status")}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Store Logo</label>
                      <div className="add-choosen">
                        {isLogo?.image ? (
                          <div className="phone-img">
                            <img
                              src={isLogo?.image}
                              alt="image"
                            />
                            <Link to="#">
                              <X
                                className="x-square-add remove-product"
                                onClick={() => handleRemoveImage('logo')}
                              />
                            </Link>
                          </div>
                        ) : (
                          <div className="input-blocks">
                            <div className="image-upload" style={{ height: '123px', width: '137px' }}>
                              <input type="file" onChange={(e) => handleUploadImage(e, 'logo')} />
                              <div className="image-uploads" style={{ padding: '43px 0px' }}>
                                <PlusCircle className="plus-down-add me-0" />
                                <h4>Add Logo</h4>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">QR Code</label>
                      <div className="add-choosen">
                        {isQrCode?.image ? (
                          <div className="phone-img">
                            <img
                              src={isQrCode?.image}
                              alt="image"
                            />
                            <Link to="#">
                              <X
                                className="x-square-add remove-product"
                                onClick={() => handleRemoveImage('qrCode')}
                              />
                            </Link>
                          </div>
                        ) : (
                          <div className="input-blocks">
                            <div className="image-upload" style={{ height: '123px', width: '137px' }}>
                              <input type="file" onChange={(e) => handleUploadImage(e, 'qrCode')} />
                              <div className="image-uploads" style={{ padding: '43px 0px' }}>
                                <PlusCircle className="plus-down-add me-0" />
                                <h4>Add QR Code</h4>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer-btn">
                    <button
                      id="modalClose"
                      type="button"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={loading}
                    >
                      {loading &&
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                      }
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreModal;
